export default function PhotoUploader() {
    photoUploaderInit()
}

function photoUploaderInit() {
    const form = document.querySelector('.pcm-step__form-upload');

    if (form) {
        let fileUploader = form.querySelector('.upload-photo');
        let fileInput = form.querySelector('.image-uploader');
        let counter = 0;

        fileUploader.addEventListener("click", function (e) {
            fileInput.click();
        });

        fileUploader.addEventListener("dragover", function (e) {
            e.preventDefault();
        });

        fileUploader.addEventListener("dragenter", function (e) {
            // prevent default to allow drop
            counter++;
            fileUploader.classList.add("drag-active");
            e.preventDefault();
        });

        fileUploader.addEventListener("dragleave", function (e) {
            // prevent default to allow drop
            e.preventDefault();
            counter--;
            if (counter === 0) {
                fileUploader.classList.remove("drag-active");
            }
        });

        fileUploader.addEventListener("drop", function (e) {
            e.preventDefault();
            var files = e.dataTransfer.files;
            if (files.length > 0) {
                var droppedImages = [].slice.call(files).filter(function (file) {
                    return file.type.indexOf("image/jpeg") == 0 || file.type.indexOf("image/png") == 0;
                });
                
                if (droppedImages.length > 0) {
                    var image = droppedImages[0];
                    var fileList = new DataTransfer();
                    fileList.items.add(image);
                    fileInput.files = fileList.files;
                    form.submit();
                  }
            }
        });

        fileInput.addEventListener("change", function (e) {
            form.submit();
        });
    }
}